import { ContentContainer } from "components/ui/display/ContentContainer";
import { PhasesProgressBar } from "components/features/projects/PhasesProgressBar";
import styled from "styled-components";
import { Button } from "components/ui/controls/Button";
import { useState } from "react";
import { ProjectPath } from "components/features/projects/ProjectPath";
import { ProjectPathUpdate } from "components/features/projects/ProjectPathUpdate";
import { Input } from "components/ui/inputs/Input";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";

export const ProjectPhases = ({content, handler}) => {

    const [newPathName, setNewPathName] = useState('');

    const addNewPath = () => {
        if(newPathName.length < 5) return;
        handler?.(prev => ({
            ...prev,
            paths: [
                ...prev.paths,
                {
                    pathUuid: crypto.randomUUID(),
                    pathName: newPathName,
                    pathUpdates: []
                }
            ]
        }));

        setNewPathName('');
    }
         
    return (
        <StyledProjectphases>
            <div className="projectMainPhase">
                <div className="moduleHeader">
                    <span>
                        Prosjektets hovedfase
                    </span>
                    Velg hvilken fase prosjektet befinnser seg i for øyeblikket.
                </div>
                <div className="content">
                    <ContentContainer dropShadow="sm" padding='lg'>
                        <PhasesProgressBar
                            phase={content.mainPhase}
                            onChange={(newPhase) => handler?.(prev => ({...prev, mainPhase: newPhase}))}
                        />
                    </ContentContainer>
                </div>
            </div>

            <div className="projectUpdates">
                <div className="moduleHeader">
                    <span>
                        Egendefinerte stier og oppdateringer
                    </span>
                    Opprett spesifikke handlingsløp for dette prosjektet.
                </div>
                {
                    content.paths.map(path => 
                        <ProjectPath
                            key={path.pathUuid}
                            path={path}
                            onUpdate={(e) => {
                                handler?.(prev => {
                                    return {
                                        ...prev,
                                        paths: prev.paths.map(p => {
                                            if(p.pathUuid !== path.pathUuid) return p;

                                            return {
                                                ...p,
                                                pathName: e
                                            }
                                        })
                                    }
                                })
                            }}
                            onRemove={() => {
                                handler?.(prev => {
                                    
                                    const filteredPaths = prev.paths.filter(p => p.pathUuid !== path.pathUuid);
                                    return {
                                        ...prev,
                                        paths: filteredPaths
                                    };
                                })
                            }}

                            onUpdateAdd = {(e) => {
                                handler?.(prev => {
                                    return {
                                        ...prev,
                                        paths: prev.paths.map(p => {
                                            if(p.pathUuid !== e.updatePath) return p;

                                            return {
                                                ...p,
                                                pathUpdates: [...p.pathUpdates, e]
                                            }
                                        })
                                    }
                                })
                            }}
                        >

                            {
                                path.pathUpdates.map(upd => 
                                <ProjectPathUpdate
                                    key={upd.updateUuid}
                                    update={upd}
                                    onEdit={(e) => {
                                        handler?.(prev => ({
                                            ...prev,
                                            paths: prev.paths.map(p => {
                                                if (p.pathUuid !== e.updatePath) return p;

                                                return {
                                                    ...p,
                                                    pathUpdates: sortUpdates(
                                                        p.pathUpdates.map(pu => {
                                                            if (pu.updateUuid !== e.updateUuid) return pu;

                                                            return {
                                                                ...pu,
                                                                date: e.date,
                                                                description: e.description
                                                            };
                                                        })
                                                    )
                                                };
                                            })
                                        }));
                                    }}
                                    onRemove={(e) => {
                                        handler?.(prev => ({
                                            ...prev,
                                            paths: prev.paths.map(p => {
                                                if (p.pathUuid !== e.updatePath) return p;

                                                return {
                                                    ...p,
                                                    pathUpdates: p.pathUpdates.filter(
                                                        pu => pu.updateUuid !== e.updateUuid
                                                    )
                                                };
                                            })
                                        }));
                                    }}
                                />)
                            }
                    
                        </ProjectPath>
                    )
                }
                <div className="newUpdatesGroup">
                    <div className="newUpdatesGroupHeader">
                        <div className="iconContainer">
                            <MaterialIcon
                                name="add"
                                weight={300}
                            />
                        </div>
                        <div className="headerText">
                            <span>Opprett en ny sti</span>
                            En sti samler en rekke relaterte oppdateringer og milepæler for en spesifikk del av prosjektet.
                        </div>
                    </div>
                    <div className="newUpdatesGroupInputs">
                        <StyledInput
                            prefix={<MaterialIcon name='conversion_path' weight={300}/>}
                            value={newPathName}
                            onChange={(e) => setNewPathName(e.target.value)}
                            placeholder="Navn på ny sti..."
                        />
                        <Button
                            text="Legg til"
                            onClick={addNewPath}
                        />
                    </div>
                </div>
            </div>
        </StyledProjectphases>
    )
}

const StyledProjectphases = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: ${({theme}) => theme.spacing.lg};

    div.moduleHeader
    {
        span
        {
            display: block;
            font-weight: 600;
            font-size: ${({theme}) => theme.fontSize.lg};
            margin-bottom: ${({theme}) => theme.spacing.sm};
            color: ${({theme}) => theme.colors.neutralSecondaryForeground};
        }

        color: ${({theme}) => theme.colors.mutedForeground};
    }

    div.projectMainPhase
    {
        padding-bottom: ${({theme}) => theme.spacing.lg};
        border-bottom: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};

        display: flex;
        flex-direction: column;
        gap: ${({theme}) => theme.spacing.lg};
    }

    div.projectUpdates
    {
        display: flex;
        flex-direction: column;
        gap: ${({theme}) => theme.spacing.lg};

        div.newUpdatesGroup
        {
            background: ${({theme}) => theme.colors.mutedBackground};
            padding: ${({theme}) => theme.spacing.lg};
            border: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
            border-radius: ${({theme}) => theme.cornerRadius.md};
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: ${({theme}) => theme.spacing.lg};

            div.newUpdatesGroupHeader
            {
                
                max-width: 500px;
                display: flex;
                gap: ${({theme}) => theme.spacing.lg};

                > div.iconContainer
                {
                    flex: 0 0 38px;
                    border: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
                    background: ${({theme}) => theme.colors.neutralPrimaryBackground};
                    border-radius: ${({theme}) => theme.cornerRadius.md};
                    height: 38px;
                    width: 38px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .plusIcon
                    {
                        color: ${({theme}) => theme.colors.mutedForeground};
                        height: ${({theme}) => theme.iconSize.md};
                        width: ${({theme}) => theme.iconSize.md};
                    }
                }

                > div.headerText
                {
                    display: flex;
                    flex-direction: column;
                    gap: ${({theme}) => theme.spacing.sm};
                    color: ${({theme}) => theme.colors.mutedForeground};

                    > span
                    {
                        display: block;
                        font-weight: 600;
                        color: ${({theme}) => theme.colors.neutralSecondaryForeground}
                    }
                }
            }

            div.newUpdatesGroupInputs
            {
                padding-left: calc(38px + ${({theme}) => theme.spacing.lg});
                display: flex;
                width: 100%;
                max-width: 500px;
                gap: ${({theme}) => theme.spacing.md};
            }
        }
    }
`

const StyledInput = styled(Input)`
    flex: 1;
`

const sortUpdates = (updates) => {
    return [...updates].sort((a, b) => 
        a.date.localeCompare(b.date)
    );
}